import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { firebaseConfig } from './firebase-config';

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');

// Connect to Firebase Functions emulator in development
if (process.env.NODE_ENV === 'development') {
	try {
		connectFunctionsEmulator(functions, 'localhost', 5001);
		console.log('Connected to Firebase Functions emulator');
	} catch (error) {
		console.log('Functions emulator already connected or failed to connect:', error.message);
	}
}

export default app;
